import React from 'react'

export interface IconInteraxProps {
  children: React.ReactNode
  backgroundShape?: 'circle' | 'square'
  backgroundColor?: string
  iconColor?: string
  size?: 'small' | 'medium' | 'large'
  className?: string
  iconClassName?: 'small' | 'medium' | 'large'
}

const IconInterax: React.FC<IconInteraxProps> = ({
  children,
  backgroundShape = 'square',
  backgroundColor = 'bg-sun-20',
  iconColor = 'text-sun',
  size = 'medium',
  className = '',
  iconClassName
}) => {
  if (!iconClassName) {
    iconClassName = size
  }
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  }

  const iconSizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8'
  }

  const shapeClasses = {
    circle: 'rounded-full',
    square: 'rounded-lg'
  }

  return (
    <div
      className={`
        ${sizeClasses[iconClassName]} 
        ${backgroundColor} 
        ${shapeClasses[backgroundShape]} 
        flex items-center justify-center
        ${className}
      `}
    >
      <div className={`${iconSizeClasses[size]} ${iconColor}`}>{children}</div>
    </div>
  )
}

export default IconInterax
